import React from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProblemSection() {
  return <Section background="cream" data-id="element-96">
      <div className="max-w-4xl mx-auto text-center" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <Quote className="w-12 h-12 text-[#C9A227] mx-auto mb-8 opacity-50" data-id="element-99" />
          <h2 className="text-3xl md:text-5xl font-serif text-[#3D2314] mb-8 leading-tight" data-id="element-100">
            ¿Estamos perdiendo la capacidad de pensar profundamente?
          </h2>
          <div className="w-24 h-1 bg-[#C9A227] mx-auto mb-10" data-id="element-101"></div>
          <p className="text-xl md:text-2xl text-[#5C3D2E] leading-relaxed font-serif italic" data-id="element-102">
            "Hoy la educación se ha vuelto superficial y rápida. Pocas veces
            aprendemos cómo pensaban realmente los grandes genios de la
            historia. Sin modelos inspiradores, es difícil desarrollar
            pensamiento profundo y creatividad."
          </p>
        </motion.div>
      </div>
    </Section>;
}